import { CopyOutlined } from '@ant-design/icons';
import 'animate.css/animate.css';
import DOMPurify from 'dompurify';
import { useState } from 'react';
import { GET_ELASTIC_RECORDS_API, GET_PRESIGNED_URL } from '../../services';
import '../../toastr.min.css';
import CustomButton from '../Button';
import customTost from '../Notification';

const ExportMetricsButton = () => {
	const [exportState, setExportState] = useState(false);
	const [logsState, setLogsState] = useState(false);
	const [exportUrl, setExportUrl] = useState('');

	const getPresignedUrl = async () => {
		try {
			const { data } = await GET_PRESIGNED_URL({
				fileName: 'pegMetrics.zip',
				bucketName: 'system-files',
			});
			if (data && data.url) {
				setExportUrl(data.url);
				setLogsState(true);
				setExportState(false);
			}
		} catch (err) {
			console.error(err);
			setExportState(false);
		}
	};

	const handleExportClick = async () => {
		try {
			setExportState(true);
			const res = await GET_ELASTIC_RECORDS_API();
			if (res?.data?.dataExist) {
				getPresignedUrl();
			} else {
				setExportState(false);
				customTost({
					type: 'error',
					message:
						'No data available to download as there is no existing forwarded data. Please initiate forwarding.',
				});
			}
		} catch (err) {
			console.error(err);
			setExportState(false);
		}
	};
	const downloadLogs = () => {
		setLogsState(false);
	};

	return (
		<>
			{!exportState ? (
				<>
					{logsState ? (
						<a
							data-testid='downloadMetrics'
							className='btnExport downloadLogs'
							onClick={downloadLogs}
							href={DOMPurify.sanitize(exportUrl)}
						>
							<CopyOutlined /> Download Peg Metrics
						</a>
					) : (
						<CustomButton
							className='btnExport peg-metrics'
							type='primary'
							size='middle'
							onClick={handleExportClick}
							icon={<CopyOutlined />}
						>
							{'Export PEG Metrics'}
						</CustomButton>
					)}
				</>
			) : (
				<CustomButton className='btnExport' type='primary' size='middle' isLoading={exportState}>
					{'Generating Peg Metrics...'}
				</CustomButton>
			)}
		</>
	);
};

export default ExportMetricsButton;
